<!-- eslint-disable vue/valid-template-root -->
<template></template>

<script>
import { mapState, mapMutations } from 'vuex';
import { handleEvent, removeEvent } from '@/figma/ui-message-handler';
import { triggerCopyToClipboard } from '@/helpers/helper';
import { createCopyEventObject } from '@/helpers/analytics';
import { trackEvent, FIGMA_COPY_COMPLETED } from '@/helpers/analytics';

export default {
  mounted() {
    handleEvent('copyToClipboardAI', async (payload) => await this.copyToClipboard(payload));
    document.addEventListener('copy', this.copyEventHandler);
  },
  beforeUnmount() {
    document.removeEventListener('copy', this.copyEventHandler);
    removeEvent('copyToClipboardAI');
  },
  computed: {
    ...mapState(['copyData', 'clipboardData']),
  },
  methods: {
    ...mapMutations([
      'setIsLoading',
      'setLayersSyncState',
      'setClipboardData',
      'setNeedsToConfirmCopy',
      'setCopyData',
    ]),
    async copyToClipboard(payload) {
      const json = JSON.parse(payload);
      if (json.webflowJson === '') {
        this.setIsLoading(false);
        return;
      }

      this.encodeJson(json);
      const success = triggerCopyToClipboard();
      if (!success) {
        this.setNeedsToConfirmCopy(true);
      }
    },
    copyEventHandler(e) {
      e.clipboardData.setData('text/plain', this.clipboardData);

      this.setLayersSyncState('success');
      trackEvent(
        FIGMA_COPY_COMPLETED,
        createCopyEventObject(this.copyData.layerType, this.copyData.startTime)
      );
      this.setIsLoading(false);
      if (this.needsToConfirmCopy) {
        this.setNeedsToConfirmCopy(false);
      }
      e.preventDefault();
      this.setCopyData({ layerId: null, startTime: null });
    },
    encodeJson(json) {
      this.setClipboardData(JSON.stringify(json, null, 2));
    },
  },
};
</script>
